import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=779857d0"
import script from "./AccountEdit?vue&type=script&lang=ts&external"
export * from "./AccountEdit?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports